import { render } from "./Loader.vue?vue&type=template&id=578abd23&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import "./Loader.vue?vue&type=style&index=0&id=578abd23&scoped=true&lang=css"

import exportComponent from "/home/tamo/projects/wedio/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-578abd23"]])

export default __exports__